<template>
  <div class="row">
    <!--  导师信息  -->
    <div class="flex xs10 offset--xs1">
      <va-card title="申请成为导师-导师信息">
        <div class="row">
          <div class="flex justify--center xs7">
            <va-button-group>
              <va-button outline class="mb-2" color="info" @click="approveModal=true" :disabled="!submitButtonStatus">
                通过申请
              </va-button>
              <va-button outline class="mb-2" color="danger" @click="rejectModel=true" :disabled="!submitButtonStatus">
                拒绝申请
              </va-button>
            </va-button-group>
          </div>
          <div class="flex justify--end xs5">
            <div class="d-flex justify--end" v-show="resume.resumeUrl">
              <a :href="resume.resumeUrl" target="_Blank">
                <va-button outline class="mb-2" color="info" slot="trigger">
                  简历<!--{{insertData.fileName}}-->
                </va-button>
              </a>
            </div>
          </div>
          <div class="flex md6 sm6 xs12">
            <va-select
              label="擅长领域"
              v-model="insertData.mentorExpertFieldIds"
              multiple
              :options="computedMentorExpertFields"
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-select
              label="所处行业"
              v-model="insertData.mentorIndustryIds"
              multiple
              :options="computedMentorIndustries"
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input
              label="擅长技能"
              v-model="insertData.skill"
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input
              label="社交帐户链接"
              v-model="insertData.socialMediaLink"
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input
              label="联系方式"
              v-model="insertData.contactInfo"
            ></va-input>
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input
              v-model="insertData.createTime"
              label="申请时间"
              disabled
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input
              v-model="computeMentorApplicationStatus(insertData.status).text"
              label="处理状态"
              disabled
            />
          </div>
          <div class="flex md6 sm6 xs12 justify--end">
            <div class="d-flex justify--end">
              <va-button class="mb-2" outline color="info" @click="clickSubmitMentorInfo" :disabled="!submitButtonStatus">
                保存导师信息
              </va-button>
            </div>
          </div>
          <div class="flex md6 sm6 xs12">
            <va-button class="mb-2" outline color="gray" @click="$router.push({ name: 'listMentorApplication' })" :disabled="!submitButtonStatus">
              返回申请列表
            </va-button>
          </div>
        </div>
        <va-modal
          v-model="approveModal"
          title="通过申请"
          okText="提交"
          position="center"
          message="请再次确认是否要通过？"
          @ok="confirmUpgradeToMentor"
        />
        <va-modal
          v-model="rejectModel"
          title="拒绝申请"
          okText="提交"
          position="center"
          message="请再次确认是否要拒绝？"
          @ok="confirmRejectApplication"
        />

      </va-card>
    </div>
    <!--  用户信息  -->
    <div class="flex xs10 offset--xs1">
      <va-card title="申请成为导师-用户信息">
        <div class="row">
          <div class='flex md12 sm6 xs12' v-show="insertData.avatar.length!==0">
            <va-card
              overlay
              :image='insertData.avatar'
              class="va-card-image"
              title="头像"
            >
            </va-card>
          </div>
          <div class='flex md6 sm6 xs12'>
            <va-input
              v-model='insertData.userUid'
              label='用户uid'
              disabled
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input
              v-model="insertData.nickname"
              label="姓名"
              disabled
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              v-model="insertData.briefInfo"
              label="一句话介绍自己"
              disabled
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              v-model="insertData.info"
              label="一段话描述自己"
              disabled
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-tree-category isOpen label="职业背景">
              <va-tree-node
                v-for="career in insertData.careerBackgrounds"
                :key="career.serviceId"
              >
                <div class="flex row align--center">
                  <va-input v-model="career.title" disabled class="mb-0"/>
                </div>
              </va-tree-node>
            </va-tree-category>
          </div>
          <div class="flex md6 sm6 xs12">
            <va-tree-category isOpen label="教育背景">
              <va-tree-node
                v-for="education in insertData.educationBackgrounds"
                :key="education.serviceId"
              >
                <div class="flex row align--center">
                  <va-input v-model="education.title" removable class="mb-0"/>
                </div>
              </va-tree-node>
            </va-tree-category>
          </div>
        </div>
      </va-card>
    </div>

  </div>
</template>

<script>

import 'vue-trix'
import mentorApplicationApi from '../../api/mentorApplication'
import { copyObject, formatTime } from '../../utils/common'
import userApi from '../../api/user'
import uploadApi from '../../api/upload'
import tagApi from '../../api/tag'
import { MENTOR_APPLICATION_STATUS, TAG_TYPE } from '../../utils/constants'
export default {
  data () {
    return {
      insertData: {
        userUid: '',
        nickname: '',
        avatar: '',
        avatarArr: [],
        info: '',
        briefInfo: '',
        createTime: '',
        mentorResumeUrl: '',
        socialMediaLink: '',
        skill: '',
        contactInfo: '',
        isActive: null,
        sortNum: null,
        mentorExpertFieldIds: [],
        mentorIndustryIds: [],
        careerBackgrounds: [],
        educationBackgrounds: [],
        status: null,
      },
      resume: {
        resumeUrl: '',
        fileName: '',
        createTime: '',
      },
      approveModal: false,
      rejectModel: false,
      saveModal: false,
      status: null,
      message: ['可以更改'],
      title: '新增用户',
      mentorIndustries: [],
      mentorExpertFields: [],
      submitButtonStatus: true,
      mentorApplicationStatus: MENTOR_APPLICATION_STATUS,
    }
  },
  created () {
    this.getMentorApplication()
    this.listMentorExpertField()
    this.listMentorIndustry()
  },
  computed: {
    computedMentorExpertFields () {
      return this.mentorExpertFields.map(x => {
        return x.name
      })
    },
    computedMentorIndustries () {
      return this.mentorIndustries.map(x => {
        return x.name
      })
    },
    flipMentorExpertFields () {
      const flipMentorExpertFields = {}
      this.mentorExpertFields.forEach(x => {
        flipMentorExpertFields[x.name] = x.id
      })
      return flipMentorExpertFields
    },
    flipMentorIndustries () {
      const flipMentorIndustries = {}
      this.mentorIndustries.forEach(x => {
        flipMentorIndustries[x.name] = x.id
      })
      return flipMentorIndustries
    },
  },
  methods: {
    getMentorApplication () {
      const params = this.$route.params
      if (params.uid != null) {
        this.title = '查看导师： ' + this.insertData.nickname
        // 通过id获取详情
        mentorApplicationApi.getMentorApplication(params.uid).then(response => {
          copyObject(response.mentorApplication, this.insertData)
          this.insertData.createTime = formatTime(this.insertData.createTime)
          // eslint-disable-next-line no-prototype-builtins
          if (response.hasOwnProperty('mentorExpertFields') && response.mentorExpertFields.length !== 0) {
            const that = this
            that.insertData.mentorExpertFieldIds = []
            response.mentorExpertFields.forEach(x => {
              that.insertData.mentorExpertFieldIds.push(x.name)
            })
          }
          // eslint-disable-next-line no-prototype-builtins
          if (response.hasOwnProperty('mentorIndustries') && response.mentorIndustries.length !== 0) {
            const that = this
            that.insertData.mentorIndustryIds = []
            response.mentorIndustries.forEach(x => {
              that.insertData.mentorIndustryIds.push(x.name)
            })
          }
          // eslint-disable-next-line no-prototype-builtins
          if (response.hasOwnProperty('careerBackgrounds')) {
            this.insertData.careerBackgrounds = response.careerBackgrounds
          }
          // eslint-disable-next-line no-prototype-builtins
          if (response.hasOwnProperty('educationBackgrounds')) {
            this.insertData.educationBackgrounds = response.educationBackgrounds
          }
          // eslint-disable-next-line no-prototype-builtins
          if (response.hasOwnProperty('resume')) {
            this.resume = response.resume
          }
        }).catch(error => {
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
      }
    },
    listMentorExpertField () {
      tagApi.listTag({ tagType: TAG_TYPE.EXPERT_FIELD_TAG.CODE }).then(response => {
        this.mentorExpertFields = response.tags
      }).catch(error => {
        console.log(error)
      })
    },
    listMentorIndustry () {
      tagApi.listTag({ tagType: TAG_TYPE.INDUSTRY_TAG.CODE }).then(response => {
        this.mentorIndustries = response.tags
      }).catch(error => {
        console.log(error)
      })
    },
    confirmUpgradeToMentor () {
      mentorApplicationApi.approveMentorApplication(this.insertData.userUid).then(response => {
        if (response.success === true) {
          this.showToast('已通过审核', {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
          this.$router.push({ name: 'listMentorApplication' })
        }
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
    confirmRejectApplication () {
      mentorApplicationApi.rejectMentorApplication(this.insertData.userUid).then(response => {
        if (response.success === true) {
          this.showToast('已拒绝申请', {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
          this.$router.push({ name: 'listMentorApplication' })
        }
      })
    },
    resetStatus () {
      this.status = null
    },
    clickSubmitUserInfo () {
      this.checkField()
      if (this.insertData.avatar.length === 0) {
        this.showToast('头像未上传，请请检查后重试！', {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
        return
      }
      this.changeButtonStatus(false)
      const data = {
        nickname: this.insertData.nickname,
        avatar: this.insertData.avatar,
        info: this.insertData.info,
        briefInfo: this.insertData.briefInfo,
        careerBackgrounds: this.insertData.careerBackgrounds,
        educationBackgrounds: this.insertData.educationBackgrounds,
      }
      if (this.insertData.userUid != null) {
        data.uid = this.insertData.userUid
        userApi.updateUser(data.uid, data).then(response => {
          if (response.user != null) {
            this.getMentorApplication()
            this.changeButtonStatus(true)
            this.showToast('用户信息更新成功', {
              duration: 1000,
              icon: 'fa-success',
              position: 'top-center',
              fullWidth: false,
            })
          }
        }).catch(error => {
          this.changeButtonStatus(true)
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
      }
      this.resetStatus()
    },
    clickSubmitMentorInfo () {
      this.checkField()
      this.changeButtonStatus(false)
      const data = {
        socialMediaLink: this.insertData.socialMediaLink,
        skill: this.insertData.skill,
        mentorExpertFieldIds: this.insertData.mentorExpertFieldIds.map(name => {
          return this.flipMentorExpertFields[name]
        }),
        mentorIndustryIds: this.insertData.mentorIndustryIds.map(name => {
          return this.flipMentorIndustries[name]
        }),
      }
      if (this.insertData.userUid != null) {
        data.userUid = this.insertData.userUid
        mentorApplicationApi.updateMentorApplication(data.userUid, data).then(response => {
          if (response.success === true) {
            this.getMentorApplication()
            this.changeButtonStatus(true)
            this.showToast('导师信息更新成功', {
              duration: 1000,
              icon: 'fa-success',
              position: 'top-center',
              fullWidth: false,
            })
          }
        }).catch(error => {
          this.changeButtonStatus(true)
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
      }
      this.resetStatus()
    },
    clickCancel () {
    },
    checkField () {
    },
    changeButtonStatus (status) {
      this.submitButtonStatus = status
    },
    addCareer () {
      this.insertData.careerBackgrounds.push({
        career: { title: '职业背景' },
      })
    },
    removeCareer (title) {
      this.insertData.careerBackgrounds = this.insertData.careerBackgrounds.filter(x => x.title !== title)
    },
    addEducation () {
      this.insertData.educationBackgrounds.push({
        education: { title: '职业背景' },
      })
    },
    removeEducation (title) {
      this.insertData.educationBackgrounds = this.insertData.educationBackgrounds.filter(x => x.title !== title)
    },
    uploadAvatar () {
      if (this.insertData.avatarArr.length === 0) return
      const formData = new FormData()
      formData.append('type', 'image')
      formData.append('file', this.insertData.avatarArr[0])
      uploadApi.uploadImage(formData).then(response => {
        this.insertData.avatar = response.url
      })
    },
    computeMentorApplicationStatus (status) {
      const data = {
        text: '',
      }
      this.mentorApplicationStatus.map(x => {
        if (x.CODE === status) {
          data.text = x.TEXT
        }
      })
      return data
    },
  },
}

</script>

<style>
.va-card-image {
  height: 200px;
  width: 200px;
  border-radius: 5%;
  margin-bottom: 10px;
}
</style>
